import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGlobalModalContext } from '@creditsights/styleguide-web';
import LockedContentModal from '../../pages/Company/CompanyDocketsTab/LockedContentModal';
import ViewDocketCasesModal from '../../pages/Company/ViewDocketCasesModal/ViewDocketCasesModal';
import AddPreferencesModal from '../../pages/MyContent/ManagePreferencesTab/Preferences/AddPreferencesModal/AddPreferencesModal';
import ConfirmDeletePreferencesModal from '../../pages/MyContent/ManagePreferencesTab/Preferences/ConfirmDeletePreferencesModal/ConfirmDeletePreferencesModal';
import ConfirmRemoveIssuersModal from '../../pages/MyContent/WatchlistsTab/ConfirmRemoveIssuersModal/ConfirmRemoveIssuersModal';
import ConfirmDeleteWatchlistModal from '../../pages/MyContent/WatchlistsTab/ConfirmDeleteWatchlistModal/ConfirmDeleteWatchlistModal';
import CopyWatchlistModal from '../../pages/MyContent/WatchlistsTab/CopyWatchlistModal/CopyWatchlistModal';
import ShareWatchlistModal from '../../pages/MyContent/WatchlistsTab/ShareWatchlistModal/ShareWatchlistModal';
import UploadIssuersModal from '../../pages/MyContent/WatchlistsTab/UploadIssuersModal/UploadIssuersModal';
import ManageColumnsModal from '../widgets/Dashboard/ManageColumnsModal';
import IssuersFilterModal from '../Filters/IssuersFilterModal';
import CompaniesWeightModal from '../TickerField/CompaniesWeightModal';
import LinkListModal from '../LinkListModal/LinkListModal';
import AnalystsModal from '../widgets/Analysts/AnalystsModal';
import CSViewModal from '../widgets/common/CSViewModal';
import CreateNewWatchlistModal from '../AddToWatchlist/CreateNewWatchlistModal/CreateNewWatchlistModal';
import ConfirmDeleteSearchesModal from '../../pages/MyContent/SearchesTab/ConfirmDeleteSearchesModal/ConfirmDeleteSearchesModal';
import SaveSearchModal from '../SaveSearchButton/SaveSearchModal/SaveSearchModal';
import AskAnalystModal from '../widgets/Analysts/AskAnalystModal';
import RestrictedArticleModal from '../RestrictedArticleAccess/RestrictedArticleModal';
import ChartDrillDownModal from '../widgets/Dashboard/ChartDrillDownModal';
import GenericModal from './GenericModal';
import NoPermissionsModal from '../NoPermissionsModal';
import CoreScoreViewModal from '../widgets/common/CoreScoreViewModal/CoreScoreViewModal';
import RPAlertsModal from '../RPAlertsModal';
import AnnouncementsVideoModal from '../widgets/Annoucements/AnnouncementsVideoModal/AnnouncementsVideoModal';

export enum MODAL_TYPES {
  UPLOAD_ISSUERS = 'UPLOAD_ISSUERS',
  ADD_PREFERENCES = 'ADD_PREFERENCES',
  ANALYST = 'ANALYST',
  ASK_ANALYST = 'ASK_ANALYST',
  COMPANIES_WEIGHT = 'COMPANIES_WEIGHT',
  CONFIRM_DELETE_PREFERENCES = 'CONFIRM_DELETE_PREFERENCES',
  CONFIRM_DELETE_WATCHLIST = 'CONFIRM_DELETE_WATCHLIST',
  SHARE_WATCHLIST = 'SHARE_WATCHLIST',
  COPY_WATCHLIST = 'COPY_WATCHLIST',
  CONFIRM_REMOVE_ISSUERS = 'CONFIRM_REMOVE_ISSUERS',
  CONFIRM_DELETE_SEARCHES = 'CONFIRM_DELETE_SEARCHES',
  CREATE_WATCHLIST = 'CREATE_WATCHLIST',
  SAVE_SEARCH = 'SAVE_SEARCH',
  CS_VIEW = 'CS_VIEW',
  CORE_SCORE_VIEW = 'CORE_SCORE_VIEW',
  LINK_LIST = 'LINK_LIST',
  RESTRICTED_ARTICLE_CONTENT = 'RESTRICTED_ARTICLE_CONTENT',
  DOCKET_VIEW_CASES = 'DOCKET_VIEW_CASES',
  DOCKET_LOCKED_CONTENT = 'DOCKET_LOCKED_CONTENT',
  FILTERS = 'FILTERS',
  CHART_DRILL_DOWN = 'CHART_DRILL_DOWN',
  MANAGE_COLUMNS = 'MANAGE_COLUMNS',
  GENERIC = 'GENERIC',
  NO_PERMISSIONS = 'NO_PERMISSIONS',
  RP_ALERTS = 'RP_ALERTS',
  ANNOUNCEMENTS_VIDEO = 'ANNOUNCEMENTS_VIDEO',
}

const MODAL_COMPONENTS = {
  [MODAL_TYPES.UPLOAD_ISSUERS]: UploadIssuersModal,
  [MODAL_TYPES.ADD_PREFERENCES]: AddPreferencesModal,
  [MODAL_TYPES.ANALYST]: AnalystsModal,
  [MODAL_TYPES.ASK_ANALYST]: AskAnalystModal,
  [MODAL_TYPES.COMPANIES_WEIGHT]: CompaniesWeightModal,
  [MODAL_TYPES.CONFIRM_DELETE_PREFERENCES]: ConfirmDeletePreferencesModal,
  [MODAL_TYPES.CONFIRM_DELETE_WATCHLIST]: ConfirmDeleteWatchlistModal,
  [MODAL_TYPES.SHARE_WATCHLIST]: ShareWatchlistModal,
  [MODAL_TYPES.COPY_WATCHLIST]: CopyWatchlistModal,
  [MODAL_TYPES.CONFIRM_REMOVE_ISSUERS]: ConfirmRemoveIssuersModal,
  [MODAL_TYPES.CONFIRM_DELETE_SEARCHES]: ConfirmDeleteSearchesModal,
  [MODAL_TYPES.CREATE_WATCHLIST]: CreateNewWatchlistModal,
  [MODAL_TYPES.SAVE_SEARCH]: SaveSearchModal,
  [MODAL_TYPES.CS_VIEW]: CSViewModal,
  [MODAL_TYPES.CORE_SCORE_VIEW]: CoreScoreViewModal,
  [MODAL_TYPES.LINK_LIST]: LinkListModal,
  [MODAL_TYPES.RESTRICTED_ARTICLE_CONTENT]: RestrictedArticleModal,
  [MODAL_TYPES.DOCKET_VIEW_CASES]: ViewDocketCasesModal,
  [MODAL_TYPES.DOCKET_LOCKED_CONTENT]: LockedContentModal,
  [MODAL_TYPES.FILTERS]: IssuersFilterModal,
  [MODAL_TYPES.CHART_DRILL_DOWN]: ChartDrillDownModal,
  [MODAL_TYPES.MANAGE_COLUMNS]: ManageColumnsModal,
  [MODAL_TYPES.GENERIC]: GenericModal,
  [MODAL_TYPES.NO_PERMISSIONS]: NoPermissionsModal,
  [MODAL_TYPES.RP_ALERTS]: RPAlertsModal,
  [MODAL_TYPES.ANNOUNCEMENTS_VIDEO]: AnnouncementsVideoModal,
};

const GlobalModal = (): React.ReactElement | null => {
  const { store, closeModal } = useGlobalModalContext();
  const { type, props } = store;
  const { pathname } = useLocation();

  useEffect(() => {
    if (type) {
      closeModal();
    }
  }, [pathname]);

  if (!type) {
    return null;
  }

  const ModalComponent = MODAL_COMPONENTS[type];
  return <ModalComponent {...props} />;
};

export default GlobalModal;
